export const getProductsStates = (resolver, products) => products?.reduce((prev, current) => ({ ...prev, [current.id]: resolver?.(current) }), {}) || {};
